import { SchedulerProConfig } from '@bryntum/schedulerpro'

export const onBeforeEventResize: SchedulerProConfig['onBeforeEventResize'] = event => {
  const locked = event.resourceRecord.getData('routeLock')

  // will block resize from a locked route
  if (locked) return false
}
